import { useState } from "react";

export default function EditorialImage({
  src,
  alt,
  label,
  testId,
  loading = "lazy",
  className = "",
}) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <figure className={`editorial-image editorial-image-fallback ${className}`} data-testid={testId}>
        <span className="mono-label">BILD NICHT VERFÜGBAR</span>
        <span>{label}</span>
      </figure>
    );
  }

  return (
    <figure className={`editorial-image ${className}`} data-testid={testId}>
      <img src={src} alt={alt} loading={loading} onError={() => setFailed(true)} />
      <figcaption>{label}</figcaption>
    </figure>
  );
}
